import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MonthlyAttendanceVerification.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { initializePendingAttendance, getDaysInMonth, getAuditLog } from '../../../utils/calculateDaysInMonthUtils';
import { getStates, fetchMonths, getDistrict, getProject, getClients, getPendingAttendance, verifyAttendanceBulk } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const MonthlyAttendanceVerification = () => {
  
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [state, setState] = useState(3);
  const [district, setDistrict] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(currentYear);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [projectResponse, setProjectResponse] = useState([]);
  const [project, setProject] = useState(null);
  const [clientResponse, setClientResponse] = useState([]);
  const [clients, setClients] = useState(1);

  const effectRan = useRef(false);
  const [isFocused, setIsFocused] = useState({
    state: false,
    district: false,
    month: false,
    year: false,
    clients: false,
  });
  const [errors, setErrors] = useState({});
  const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
  const yearInputRef = useRef(null);
  const isFetchDataEnabled = state && district && month && year;
  const [selected, setSelected] = useState('');

  // Function to calculate days in a month
  // const getDaysInMonth = (monthId, year) => {
  //   const monthIndex = monthId - 1; // Convert to 0-based for Date object
  //   if (!monthId || !year) return 0;
  //   const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
  //   const monthsWith30Days = [4, 6, 9, 11];
  //   if (monthsWith31Days.includes(monthId)) {
  //     return 31;
  //   } else if (monthsWith30Days.includes(monthId)) {
  //     return 30;
  //   } else if (monthId === 2) {
  //     const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     return isLeapYear ? 29 : 28;
  //   }
  //   return 0;
  // };

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
        const data = await getStates();
        setStateOptions(
          data.map(item => ({
            value: item.id,
            label: capitalizeFirstLetter(item.stateName),
          }))
        );
      } catch (error) {
        console.error('Error fetching states:', error);
        setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
      }
    };

    if (!effectRan.current) {
      fetchStates();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);

  // Fetch months
  // useEffect(() => {
  //   const fetchMonths = async () => {
  //     try {
  //       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
  //       const now = new Date();
  //       const currentYear = now.getFullYear();
  //       const currentMonth = now.getMonth() + 1; // Jan=1
  //       const currentDate = now.getDate();
  //       const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate(); // ✅ last day of current month

  //       const months = response.data
  //         .map(item => {
  //           let daysInMonth;

  //           // If it's the current month of the current year
  //           if (year === currentYear && item.monthId === currentMonth) {
  //             daysInMonth = currentDate;
  //           } else {
  //             daysInMonth = new Date(year, item.monthId, 0).getDate();
  //           }

  //           return {
  //             value: item.monthId,
  //             label: item.monthName,
  //             days: daysInMonth,
  //           };
  //         })
  //         .sort((a, b) => a.value - b.value);

  //       let filteredMonths = months;
  //       if (year) {
  //         if (year === currentYear) {
  //           filteredMonths = months.filter(m => {
  //             if (m.value < currentMonth) return true; // past months always visible
  //             if (m.value === currentMonth) {
  //               // ✅ Show current month only if today is the last day
  //               return currentDate === lastDayOfCurrentMonth;
  //             }
  //             return false;
  //           });
  //         } else if (year > currentYear) {
  //           filteredMonths = []; // future year → no months
  //         } else {
  //           filteredMonths = months; // past year → all months
  //         }
  //       }
  //       setMonthOptions(filteredMonths);
  //     } catch (error) {
  //       console.error('Error fetching months:', error);
  //       setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
  //     }
  //   };
  //   fetchMonths();
  // }, [year]);

  useEffect(() => {
    const loadMonths = async () => {
      try {
        const months = await fetchMonths(year);
        setMonthOptions(months);
      } catch (error) {
        console.error("Error fetching months:", error);
        setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
      }
    };
    loadMonths();
  }, [year]);

  // Fetch districts when state changes
  useEffect(() => {
    if (state) {
      const fetchDistricts = async () => {
        try {
          // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
          const data = await getDistrict(state);
          setDistrictOptions(
            data.map(item => ({
              value: item.districtId,
              label: item.districtName,
            }))
          );
        } catch (error) {
          console.error('Error fetching districts:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
        }
      };
      fetchDistricts();
    } else {
      setDistrictOptions([]);
      setDistrict(null);
      setAttendanceData([]);
      setHasFetched(false); // Reset fetch status
    }
  }, [state]);
  useEffect(() => {
    if (state) {
      const fetchClients = async () => {
        try {
          const data = await getClients(state);
          setClientResponse(
            data.map(client => ({
              value: client.id,
              label: client.clientName,
            }))
          );
        } catch (error) {
          console.error('Error fetching clients:', error);
          setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
        }
      };
      fetchClients();
    } else {
      setClientResponse([]);
      setClients(null);



    }
  }, [state]);
  useEffect(() => {
    if (clients) {
      const fetchProjects = async () => {
        try {
          const data = await getProject(clients);
          setProjectResponse(data.map(pro => ({
            value: pro.id,
            label: pro.projectCode,
          })));
        } catch (error) {
          console.error('Error fetching projects:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
        }
      };

      fetchProjects();
    } else {
      setProjectResponse([]); // Reset projects if no client is selected
    }
  }, [clients]);

  // Clear attendance data and fetch status when any dropdown changes
  // useEffect(() => {
  //   const fetchProjects = async () => {
  //     try {
  //       const data = await getProjects();
  //       setProjectResponse(
  //         data.map(pro => ({
  //           value: pro.id,
  //           label: pro.projectCode,
  //         }))
  //       );
  //     } catch (error) {
  //       console.error('Error fetching projects:', error);
  //       setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
  //     }
  //   };
  //   if (!effectRan.current) {
  //     fetchProjects();
  //   }
  //   return () => {
  //     effectRan.current = true;
  //   }
  // }, [state, district, year]);


  // Clear attendance data and fetch status when any dropdown changes
  useEffect(() => {
    setAttendanceData([]);
    setOriginalData([]);
    setHasFetched(false);
  }, [state, district, month, year, project]); // ✅ Add project to depende


  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : null;
    switch (field) {
      case 'state':
        setState(value);
        setDistrict(null);
        setMonth(null);
        setProject(null); // ✅ Clear project when state changes
        setClients(null);
        break;
      case 'district':
        setDistrict(value);
       // setProject(null); // ✅ Clear project when district changes
        break;
      case 'clients':
        setClients(value);
        setProject(null);
        // setProjectResponse([]);
        // setEmployees([]);
        // setEmployeeData([]);
        break;
      case 'month':
        setMonth(value);
        break;
      case 'project':
        setProject(value); // ✅ Handle project selection
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };


  const handleYearChange = (date) => {
    const newYear = date ? date.getFullYear() : null;
    setYear(newYear);
    setMonth(null);
    setErrors(prev => ({ ...prev, year: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!state) newErrors.state = 'State is required';
    if (!district) newErrors.district = 'District is required';
    if (!month) newErrors.month = 'Month is required';
    if (!year) newErrors.year = 'Year is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const data = await getPendingAttendance({
        districtId: district,
        month,
        year,
        projectId: project,
      });

      console.log("API response:", data);

      setHasFetched(true);
      setOriginalData(data);

      const initializedData = initializePendingAttendance(data, month, year);

      setAttendanceData(initializedData);

      if (initializedData.length === 0) {
        alert("No employees found for the selected criteria.");
      } else {
        alert("Attendance data fetched successfully!");
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setErrors((prev) => ({
        ...prev,
        general: "Failed to fetch attendance data",
      }));
      setHasFetched(true);
      alert("Failed to fetch attendance data. Please try again.");
    }
  };

  // const handleAttendanceInputChange = (index, field, value) => {
  //   const daysInMonth = getDaysInMonth(month, year);
  //   let newValue = value === '' ? '' : parseInt(value) || 0;

  //   setAttendanceData(prev =>
  //     prev.map((item, i) => {
  //       if (i === index) {
  //         const updatedItem = { ...item };

  //         if (field === 'presentDays') {
  //           // Cap presentDays at daysInMonth
  //           if (newValue !== '' && newValue > daysInMonth) newValue = daysInMonth;
  //           updatedItem.presentDays = newValue;

  //           // Ensure presentDays + casualLeave does not exceed daysInMonth
  //           if (newValue !== '' && (newValue + (updatedItem.casualLeave || 0)) > daysInMonth) {
  //             updatedItem.casualLeave = daysInMonth - newValue;
  //           }
  //         }

  //         if (field === 'casualLeave') {
  //           const maxLeaves = item.leaves || 0;
  //           // Cap casualLeave at available leaves
  //           if (newValue !== '' && newValue > maxLeaves) newValue = maxLeaves;
  //           // Cap casualLeave so presentDays + casualLeave ≤ daysInMonth
  //           const allowedLeaves = daysInMonth - (updatedItem.presentDays || 0);
  //           if (newValue !== '' && newValue > allowedLeaves) newValue = allowedLeaves;
  //           updatedItem.casualLeave = newValue;
  //         }

  //         // Recalculate daysAbsent
  //         const presentDays = updatedItem.presentDays || 0;
  //         const casualLeave = updatedItem.casualLeave || 0;
  //         updatedItem.daysAbsent = daysInMonth - (presentDays + casualLeave);
  //         if (updatedItem.daysAbsent < 0) updatedItem.daysAbsent = 0;

  //         // Recalculate usedLeaves from originalData
  //         const originalLeaves = originalData[i]?.usedLeaves || 0;
  //         updatedItem.usedLeaves = Math.max(originalLeaves + (updatedItem.casualLeave || 0), 0);

  //         return updatedItem;
  //       }
  //       return item;
  //     })
  //   );

  //   setErrors(prev => ({ ...prev, [`${field}_${index}`]: null }));
  // };


  // const validateAttendanceInputs = () => {
  //   const newErrors = {};
  //   const daysInMonth = getDaysInMonth(month, year);

  //   attendanceData.forEach((row, index) => {
  //     const presentDays = Number(row.presentDays) || 0;
  //     const casualLeave = Number(row.casualLeave) || 0;
  //     const daysAbsent = row.daysAbsent || 0;
  //     const maxLeaves = row.leaves || 0;

  //     console.log(`Validating row ${index} (${row.fullName}):`, {
  //       presentDays,
  //       casualLeave,
  //       daysAbsent,
  //       daysInMonth,
  //       maxLeaves,
  //       sum: presentDays + casualLeave + daysAbsent,
  //     });

  //     if (presentDays > daysInMonth) {
  //       newErrors[`presentDays_${index}`] = `Present days cannot exceed ${daysInMonth} days`;
  //     }
  //     if (casualLeave > maxLeaves) {
  //       newErrors[`casualLeave_${index}`] = `Casual leave cannot exceed ${maxLeaves} days`;
  //     }
  //     if (presentDays + casualLeave + daysAbsent !== daysInMonth) {
  //       newErrors[`daysAbsent_${index}`] = `Total days (Present + Casual Leave + Absent) must equal ${daysInMonth} (Got ${presentDays + casualLeave + daysAbsent})`;
  //     }
  //     if (presentDays < 0) {
  //       newErrors[`presentDays_${index}`] = 'Present days cannot be negative';
  //     }
  //     if (casualLeave < 0) {
  //       newErrors[`casualLeave_${index}`] = 'Casual leave cannot be negative';
  //     }
  //     if (daysAbsent < 0) {
  //       newErrors[`daysAbsent_${index}`] = 'Days absent cannot be negative';
  //     }
  //   });

  //   console.log('Validation errors:', newErrors);
  //   setErrors(prev => ({ ...prev, ...newErrors }));
  //   return Object.keys(newErrors).length === 0;
  // };

  const handleVerification = async () => {
    // const fullNameAudit = localStorage.getItem("full_name");
    // const role = localStorage.getItem("role");
    // const employeeIdAudit = localStorage.getItem("employeeId");

    const remarks = document.getElementById("resubmit")?.value || "";

    const payload = {
      month,
      year,
      districtId: district,
      projectId: project,
      status: selected.toUpperCase(), // VERIFIED or RESUBMIT
      auditLog: getAuditLog(),
      remarks,
    };

    try {
      await verifyAttendanceBulk(payload);

      alert("Attendance Verified Successfully!");

      // ✅ Better way to clear state
      handleClear();
      setSelected("");
      if (document.getElementById("resubmit")) {
        document.getElementById("resubmit").value = "";
      }
    } catch (error) {
      console.error("Error saving attendance data:", error.response?.data || error.message);
      alert(
        error.response?.data?.error || "Failed to save attendance data. Please try again."
      );
    }
  };


  const handleClear = () => {
    setDistrict('');
    setState('');
    setMonth('');
    setYear('');
    setProject('');
    setSelected('');
  }

  const gotoDashboard = () => {
    navigate('/dashboard');
  };

  // const selectStyles = {
  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
  //   menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
  //   control: provided => ({ ...provided, padding: '1px' }),
  //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
  // };


  const minDate = new Date(2000, 0, 1);
  const maxDate = new Date(currentYear, 11, 31);
  // ✅ Check if all employees have presentDays filled
  const isAllPresentDaysFilled =
    attendanceData.length > 0 &&
    attendanceData.every(
      row =>
        row.presentDays !== '' &&
        row.presentDays !== null &&
        row.presentDays !== undefined &&
        Number(row.presentDays) > 0 // ✅ must be greater than 0
    );

  return (
    <div className="monthly-attendance-container">
      <div className="monthly-attendance-box">
        <h2 className="monthly-attendance-heading">Monthly Attendance Verification</h2>
        {errors.general && <div className="error-message">{errors.general}</div>}
        <form onSubmit={handleSubmit}>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                <Select
                  name="state"
                  options={stateOptions}
                  value={stateOptions.find(opt => opt.value === state) || null}
                  onChange={option => handleInputChange(option, 'state')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>State
                </label>
                {errors.state && <div className="error-message">{errors.state}</div>}
              </div>
            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                <Select
                  name="district"
                  options={districtOptions}
                  value={districtOptions.find(opt => opt.value === district) || null}
                  onChange={option => handleInputChange(option, 'district')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>District
                </label>
                {errors.district && <div className="error-message">{errors.district}</div>}
              </div>
            </div>
          </div>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                <DatePicker
                  selected={year ? new Date(year, 0, 1) : null}
                  onChange={handleYearChange}
                  onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                  dateFormat="yyyy"
                  showYearPicker
                  placeholderText=""
                  className="monthly-attendance-date-picker"
                  minDate={minDate}
                  maxDate={maxDate}
                  ref={yearInputRef}
                />
                <label>
                  <span className="required">*</span>Year
                </label>
                {errors.year && <div className="error-message">{errors.year}</div>}
              </div>
            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                <Select
                  name="month"
                  options={monthOptions}
                  value={monthOptions.find(opt => opt.value === month) || null}
                  onChange={option => handleInputChange(option, 'month')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Month
                </label>
                {errors.month && <div className="error-message">{errors.month}</div>}
              </div>
            </div>
          </div>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                <Select
                  name="clients"
                  options={clientResponse}
                  value={clientResponse.find(opt => opt.value === clients) || null}
                  onChange={option => handleInputChange(option, 'clients')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label> <span className="required">*</span>Client</label>
                {errors.clients && <div className="error-message">{errors.clients}</div>}
              </div>

            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                <Select
                  name="project"
                  options={projectResponse}
                  value={projectResponse.find(opt => opt.value === project) || null}
                  onChange={option => handleInputChange(option, 'project')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Project
                </label>
                {errors.project && <div className="error-message">{errors.project}</div>}
              </div>
            </div>

          </div>
          <div className="monthly-attendance-btn-div">
            <button
              type="submit"
              className="monthly-attendance-btn"
              disabled={!isFetchDataEnabled}
            >
              Fetch Data
            </button>
          </div>
        </form>
      </div>
      {hasFetched && (
        <div className="attendance-table-container">
          <table className="attendance-table">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Employee Id</th>
                <th>Employee Name</th>
                <th>Designation</th>
                <th>DHQ/ Godown Name</th>
                <th>No of Days in Month</th>
                <th>No of Days Present</th>
                <th>Casual Leave (CL)</th>
                <th>No of Days Absent</th>
                <th>Total No of Days Present</th>
                <th>CL Used Status</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>
                    No data available
                  </td>
                </tr>
              ) : (
                attendanceData.map((row, index) => {
                  const daysInMonth = getDaysInMonth(month, year);
                  const daysAbsent = row.daysAbsent || 0;
                  const payableDays = daysAbsent === 0 ? daysInMonth : (row.presentDays || 0) + (row.casualLeave || 0);
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.employeeId || 'N/A'}</td>
                      <td>{row.fullName || 'N/A'}</td>
                      <td>{row.designation || 'N/A'}</td>
                      <td>{row.location || 'N/A'}</td>
                      <td>{daysInMonth}</td>
                      <td>
                        {row.presentDays}
                      </td>
                      <td>

                        {row.casualLeave}
                      </td>
                      <td>{row.daysAbsent || 0}</td>
                      <td>{payableDays >= 0 ? payableDays : 0}</td>
                      <td>{row.usedLeaves}/{row.totalLeaves}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
          {attendanceData.length > 0 && (
            <>
              <div className="checkbox-design">
                <div>
                  <input
                    type="checkbox"
                    id="verified"
                    checked={selected === 'verified'}
                    onChange={() => setSelected('verified')}
                  />
                  <label htmlFor="approve">Approve</label>
                </div>
                <div>
                  <input
                    type="checkbox"
                    id="resubmit"
                    checked={selected === 'resubmit'}
                    onChange={() => setSelected('resubmit')}
                  />
                  <label htmlFor="resubmit">Resubmit</label>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" htmlFor="resubmit">Remarks</label>
                <textarea class="form-textarea" id="resubmit"></textarea>
              </div>
            </>
          )}
          {attendanceData.length > 0 && (
            <div className="monthly-submit-btn-div">
              <button onClick={gotoDashboard} className="monthly-close-btn">Close</button>
              <button
                type="button"
                className="monthly-attendance-btn"
                onClick={handleVerification}
              //disabled={!isAllPresentDaysFilled} // ✅ disable if not all presentDays filled
              >
                Verify
              </button>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default MonthlyAttendanceVerification;